/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */

/**
 * Type of animal
 */
export type ReportBodyDtoAnimalType =
  (typeof ReportBodyDtoAnimalType)[keyof typeof ReportBodyDtoAnimalType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReportBodyDtoAnimalType = {
  vertebrate: 'vertebrate',
  invertebrate: 'invertebrate',
} as const;
